<template>
  <div class="container settings">
    <h2 style="text-align:center">
      Vous ne pouvez pas modifier les paramètres de votre compte pour l'instant.
      Cette fonctionnalité arrivera prochainement 😎
    </h2>
    <form v-if="false" class="settings__form">
      <md-field>
        <label>Email</label>
        <md-input type="email" v-model="email"></md-input>
      </md-field>
      <md-field>
        <label>New password</label>
        <md-input type="password" v-model="password"></md-input>
      </md-field>
      <md-field>
        <label>Repeat new password</label>
        <md-input type="password" v-model="passwordRepeate"></md-input>
      </md-field>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      email: "myemail@ea.com",
      password: "",
      passwordRepeate: "",
    };
  },
};
</script>
<style lang="scss" scoped>
.settings {
  &__form {
    padding: 15px;
    border-radius: $radius;
    box-shadow: $box-shadow;
    margin-top: 20px;
  }
}
</style>
